import { lazy, Suspense } from 'react';

const LegacyLabTemplateModal = lazy(async () => {
  const module = await import('@old/features/silobags/lab-template-modal/lab-template-modal');

  return { default: module.DownloadLabTemplateModal };
});

type Props = {
  open: boolean;
  silobagIds: readonly string[];
  onClose: () => void;
};

export function LabTemplateModal({ open, silobagIds, onClose }: Props) {
  if (!open) return null;

  return (
    <Suspense fallback={null}>
      <LegacyLabTemplateModal open onClose={onClose} selectedSilobags={silobagIds.map((id) => ({ id }))} />
    </Suspense>
  );
}
